module.exports = __webpack_public_path__ + "static/media/calendar.74420abb.svg";